module.exports = __webpack_public_path__ + "static/images/resources.0f31b9f775976528bfe023da60f5166c.svg";